module.exports = __webpack_public_path__ + "static/media/glowco_4_ez tunes in black.54bc63a8.jpeg";